import { Flex } from "@radix-ui/themes";
import { on } from "events";
import { useEffect, useState } from "react";

const SubjectiveQuestion = ({ question, item, mode, defaultAnswer = '', onAnswer, index, isMandatory, onValidate }: { isMandatory?: boolean; question: string, item: any, index: number, defaultAnswer?: string, onAnswer: (answer: string, item: any, answerId?: any) => void, mode: any; onValidate?: (index: number, isValid: boolean) => void }) => {

  const [answer, setAnswer] = useState<string>(defaultAnswer)
  const handleChange = (value: string) => {
    setAnswer(value);

    if (mode === "survey") {
      onAnswer(value, index, item.answer?.[0]?.answerId);
    } else {
      onAnswer(value, index);
    }

    if (isMandatory) {
      onValidate(index, value.trim().length > 0);
    }
  };

  useEffect(() => {
    if (typeof onValidate === "function") {
      if (isMandatory) {
        onValidate(index, answer.trim().length > 0);
      }
    }
  }, [answer, isMandatory, index, onValidate]);
  return (
    <Flex direction="column" gap="3" style={{ maxWidth: 700 }}>
      <label className="block mb-2 text-normal font-bold text-app-gray-medium">
        {question}
        {isMandatory && <span className="text-red-600">*</span>}
      </label>
      <textarea
        id="message"
        className="block p-2.5 h-56 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:outline-none"
        placeholder="Type your response here"
        onChange={(event) => {
          handleChange(event.target.value)
        }}
        value={answer}
      ></textarea>
    </Flex>
  );
};

export default SubjectiveQuestion;